import { requestGetProfileManagement } from 'app/api/profile'
import { ProfileMessageCode } from 'app/api/profile/constant'
import { IParamsGetProfileManagement } from 'app/api/profile/model/management'
import { usePagination } from 'app/hook'
import { IUser } from 'app/model/user.model'
import { IDiscountVoucher } from 'app/api/marketing/discount-voucher/model'
import { requestMyReferral, requestMyVoucher } from 'app/api/profile'
import { IPayLoadGetList } from 'app/common/interface'
import { getToken } from 'app/service/storage/storage-service'
import { isEqual } from 'lodash'
import { ResponseType } from 'parkway-web-common'
import { useInfiniteQuery } from 'react-query'
import { ProfileKeys } from '../query-key/profile'
import { IResponseQueryList } from '../model/common'

export function useGetProfileList(
  params?: IParamsGetProfileManagement,
  enabled = true,
) {
  const token = getToken()
  const { getNextPageParam } = usePagination()
  return useInfiniteQuery<ResponseType<IUser[]>, undefined>(
    ProfileKeys.listProfile(params),
    async data => {
      const res: ResponseType<IUser[]> = await requestGetProfileManagement({
        ...params,
        ...data?.pageParam,
      })

      if (
        isEqual(
          res?.msgcode,
          ProfileMessageCode.ProfileManagement.successGetData,
        )
      ) {
        return res
      }

      return Promise.reject(res)
    },
    {
      enabled: !!token && enabled,
      getNextPageParam,
    },
  )
}

export function useGetMyVoucherList(params?: IPayLoadGetList, enabled = true) {
  const token = getToken()

  return useInfiniteQuery<IResponseQueryList<IDiscountVoucher[]>, undefined>(
    ProfileKeys.listMyVoucher(params),
    async () => {
      try {
        const res: ResponseType<IDiscountVoucher[]> = await requestMyVoucher(
          params,
        )

        if (
          isEqual(
            res?.msgcode,
            ProfileMessageCode.ProfileManagement.successGetData,
          )
        ) {
          const data: IDiscountVoucher[] = res?.data || []
          return {
            data,
            total: data.length ?? 0,
            totalItem: res?.metadata?.totalItem ?? 0,
          }
        }
        return {
          data: [],
          total: 0,
          totalItem: res?.metadata?.totalItem ?? 0,
        }
      } catch (error: any) {
        return {
          data: [],
          total: 0,
          totalItem: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}

export function useGetReferralVoucherList(
  params?: IPayLoadGetList,
  enabled = true,
) {
  const token = getToken()
  return useInfiniteQuery<IResponseQueryList<IDiscountVoucher[]>, undefined>(
    ProfileKeys.listReferralVoucher(params),
    async () => {
      try {
        const res: ResponseType<IDiscountVoucher[]> = await requestMyReferral(
          params,
        )

        if (
          isEqual(
            res?.msgcode,
            ProfileMessageCode.ProfileManagement.successGetData,
          )
        ) {
          const data: IDiscountVoucher[] = res?.data || []
          return {
            data,
            total: data.length ?? 0,
            totalItem: res?.metadata?.totalItem ?? 0,
          }
        }
        return {
          data: [],
          total: 0,
          totalItem: res?.metadata?.totalItem ?? 0,
        }
      } catch (error: any) {
        return {
          data: [],
          total: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}
